<template>
  <v-row v-if="checkPermission(const_permissions.TRANSACTION_SHOW_EVENTS)" class="pa-0" dense>
    <v-col>
      <TitleCard test-id="transaction-events-title"
        :extra="`${transaction_content?.events ? transaction_content?.events.length : 0} ${$vuetify.lang.t('$vuetify.events')}`"
        :icon="const_icons.TRANSACTION" :title="$vuetify.lang.t('$vuetify.transactionEventsRegistered')" />

      <v-row v-if="transaction_days.length !== 0 && checkPermission(const_permissions.TRANSACTION_SHOW_EVENTS)">
        <v-col class="pa-0 pl-md-10 mt-4 transaction-events-container" test-id="transaction-events-container">
          <v-row class="px-2" dense justify="end">
            <a test-id="link-events-info" class="link-help cts-link cts-font-size-3 cts-color-primary-alternative pr-2"
              :title="$vuetify.lang.t('$vuetify.eventsInfo')" @click="eventsInfoDialog = true">
              <v-icon class="mr-1" color="var(--primary-alternative)" size="20">
                mdi-information-variant
              </v-icon>
              {{ $vuetify.lang.t('$vuetify.aboutEvents') }}
            </a>
          </v-row>
          <TransactionEventsDetails v-if="eventsInfoDialog" :events="transaction_days.map((day) => day.events).flat()"
            @close="eventsInfoDialog = false" />
          <v-timeline v-for="(day, key) in transaction_days" :key="key" class="pt-0 d-none d-md-block"
            test-id="transaction-events-timeline">
            <v-timeline-item color="var(--primary-alternative)" hide-dot right>
              <template v-slot:opposite>
                <h2 test-id="title-timeline-events">
                  {{ capitalize(dayjs.unix(day.day_at).format(const_global.DATE_TIME_FORMAT_E)) }}
                </h2>
              </template>
            </v-timeline-item>
            <v-timeline-item test-id="content-events-card" v-for="(event, i) in day.events" :key="i"
              :icon="getEventIcon(event.key)" :icon-color="getEventColor(event.key)" class="py-0 event-timeline-row"
              fill-dot right>
              <template v-slot:opposite>
                <span test-id="time-events-card"> {{ dayjs.unix(event.event_at).format(const_global.DATE_TIME_FORMAT_C)
                }}</span>
              </template>
              <v-row justify="space-between">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium" test-id="title-events-card">
                      {{ capitalize(event.event) }}
                    </v-list-item-title>
                    <v-list-item-subtitle :title="event.subtitle" class="cts-font-size-4"
                      test-id="subtitle-events-card">
                      <v-icon test-id="icon-events-card" v-if="event.intervener"
                        :color="getIntervenerColor(transaction_content?.interveners.findIndex(i => i.client_id == event.intervener))"
                        small>
                        person
                      </v-icon>
                      {{ capitalize(event.subtitle) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-row>
            </v-timeline-item>
          </v-timeline>
          <TransactionEventMobile v-if="isMobile" :capitalize="capitalize" :transaction_days="transaction_days"
            :dayjs="dayjs" :getEventIcon="getEventIcon" :getEventColor="getEventColor" />


        </v-col>
        <v-col v-if="transactionStatus.id === 'error'" class="pl-md-14 py-4" test-id="transaction-no-events-registered">
          <span class="cts-color-tertiary cts-font-size-3">{{ $vuetify.lang.t('$vuetify.notEventsRegistered') }}</span>
        </v-col>
      </v-row>
      <v-row v-if="!hasEvents" class="pl-md-14 py-4" test-id="transaction-no-events">
        <v-col>
          <span class="cts-color-tertiary cts-font-size-3">{{ $vuetify.lang.t('$vuetify.notEvents') }}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

</template>
<script>
import const_icons from "@/constants/icons";
import const_global from "@/constants/global";
import TitleCard from "@/components/sections/transactions/components/TitleCard.vue";
import TransactionEventsDetails from "@/components/sections/transactions/components/TransactionEventsDetails.vue";
import const_events from "@/constants/events";
import { getIntervenerColor } from "@/plugins/helpers";
import TransactionEventMobile from "../components/TransactionEventMobile.vue";


export default {

  name: "TransactionDetailEventsSection",
  components: {
    TitleCard,
    TransactionEventsDetails,
    TransactionEventMobile
  },
  data() {
    return {
      const_icons,
      const_global,
      eventsInfoDialog: false,
    };
  },
  props: {
    transactionStatus: Object,
    transaction_content: Object,
    capitalize: Function,
    checkPermission: Function,
    transaction_days: Array,
    lastUpdate: Object,
    dayjs: Function,
    const_permissions: Object,
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    hasEvents() {
      return this.transaction_days.length > 0;
    },
  },
  methods: {
    getIntervenerColor,
    getEventIcon(eventKey) {
      if (typeof const_events[this.formatEventKey(eventKey)] != "undefined" && const_events[this.formatEventKey(eventKey)].icon !== "") {
        return const_events[this.formatEventKey(eventKey)].icon;
      }
      return const_icons.EVENT_DEFAULT;
    },
    getEventColor(eventKey) {
      let color;
      if (typeof const_events[this.formatEventKey(eventKey)] != "undefined" && const_events[this.formatEventKey(eventKey)].color !== "") {
        color = const_events[this.formatEventKey(eventKey)].color;
      }
      if (!color) {
        return "var(--primary)";
      }
      return color;
    },
    formatEventKey(key) {
      return key.replace(".", "_").toUpperCase();
    },

  }
};

</script>
<style lang="scss">
.transaction-view-container {
  .transaction-events-container {
    color: var(--tertiary);

    .link-help {
      display: inline-flex;
    }

    .link-help:hover {
      i {
        color: var(--primary-alternative) !important;
      }

      opacity: 0.8;
    }

    .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)::before {
      left: 217px !important;
    }

    .event-timeline-row:hover {
      background-color: #fafafa !important;
    }

    .v-timeline-item {
      justify-content: flex-end;
      padding-bottom: 0;
      padding-top: 16px;

      .v-timeline-item__body {
        max-width: -webkit-fill-available !important;

        .v-list-item__content {
          align-self: center;
          padding: 16px 0;

          .v-list-item__title {
            margin-bottom: 4px;
          }

          .v-list-item__subtitle {
            -webkit-line-clamp: 4;
          }
        }
      }

      .v-timeline-item__dot {
        z-index: 1;
        width: 34px;
        height: 34px;

        .v-timeline-item__inner-dot {
          background-color: var(--clear) !important;
          border-width: 1px;
          border-style: solid;
          border-radius: 4px;
          border-color: var(--card-border) !important;
          box-shadow: 0px 0px 2px 0px var(--card-border) !important;
        }

        .v-icon {
          font-size: 20px;
        }
      }

      .v-timeline-item__opposite {
        width: 170px;
        max-width: 170px;
        min-width: 170px;
      }

     
      
    }
  }
}
</style>